import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-cube-grid',
    templateUrl: './cube-grid.component.html',
    styleUrls: ['./cube-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CubeGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
